/**
 * Amplitude sends user_properties as a base64-encoded `x-amp-exp-user` header on Experiment
 * fetches, and stores them uncapped via the Analytics SDK's identify(). Internal users with
 * access to 1000+ tenants can overflow the server's header size limit (431 Request Header
 * Fields Too Large). Cap list-valued user_properties to keep both paths safe.
 */
export const MAX_ITEMS_FOR_EXPERIMENT_HEADER = 100;
